// extracted by mini-css-extract-plugin
export var wrapper = "Slider-module--wrapper--DB5uN";